import React, { PureComponent } from "react";
import { getValueFieldNameForFilter, getValueWhenInFilter } from "../Utils";
import Mandatory from "./Mandatory";
import AttributeInfo from "./AttributeInfo";
import Select from "react-select";

export default class CCCOptionsObservation extends PureComponent {
  render() {
    let {
      placeholder,
      attribute,
      index,
      changeField,
      handleOnBlur
    } = this.props;
    let description = attribute.description || attribute.title;

    let options = attribute.options || [];
    return (
      <div
        key={index}
        className="col-12 my-1 pb-2"
        style={{ backgroundColor: "#fff" }}
        ref={attrEl => {
          if (this.props.setAttributeRef) {
            this.props.setAttributeRef(attribute.name, attrEl);
          }
        }}
      >
        {!placeholder && (
          <label style={{ fontWeight: 500 }}>
            {description}
            <Mandatory mandatory={attribute.mandatory} />
          </label>
        )}
        <div className="d-flex flex-column">
          <Select
            placeholder={placeholder ? description : ""}
            style={{
              border: attribute.error
                ? "2px solid #f86c6b"
                : "1px solid #c0c0c0",
              backgroundColor: attribute.error ? "#faebd7" : "#fff"
            }}
            name="form-field-name"
            value={getValueWhenInFilter(attribute)}
            onChange={option => {
              attribute.value = getValueFieldNameForFilter(
                attribute,
                option ? option.value : null
              );
              changeField(index, attribute);
            }}
            valueKey="valueSelect"
            options={options
              .filter(
                o =>
                  o.valueObservation &&
                  o.valueObservation.value &&
                  o.valueObservation.value.valueCode
              )
              .map(option => {
                let val = option.valueObservation.value.valueCode;
                return {
                  valueSelect: val.code,
                  value: JSON.parse(JSON.stringify(option.valueObservation)),
                  label: val.display
                };
              })}
            onBlur={() => {
              handleOnBlur(index, attribute);
            }}
          />
          {placeholder && <Mandatory mandatory={attribute.mandatory} />}
          {attribute.error && (
            <div className="ob-if invalid-feedback d-block">
              {attribute.error}
            </div>
          )}
          <AttributeInfo info={attribute.info} />
        </div>
      </div>
    );
  }
}
